<template>
  <div>
    <div
      v-if="objectData"
    >
      <objects-preview
        :object-data="objectData"
        :location-of-object="objectLocation"
      />
    </div>
    <div v-else>
      <!-- you cant see me, i am an error object placeholder -->
    </div>
  </div>
</template>

<script>
// import ObjectPricePerWeek from 'components/ObjectPricePerWeek.vue';
// import WatchBtn from 'components/WatchBtn.vue';
// import LazyPhoto from 'components/LazyPhoto.vue';
// import RouterLinkSimple from 'components/RouterLinkSimple.vue';
// import RatingStarsCanvas from 'components/RatingStarsCanvas.vue';
import ObjectsPreview from 'components/ObjectsPreview.vue';


/* ICONS */

export default {
  name: 'LastSeenObject',
  components: {
    // ObjectPricePerWeek,
    // WatchBtn,
    // LazyPhoto,
    // RouterLinkSimple,
    // RatingStarsCanvas,
    ObjectsPreview,
  },
  props: {
    lastSeenObjectNumber: {
      required: true,
      type: [Number, String],
      validator(value) {
        return value === 0 || parseInt(value, 10);
      },
    },
  },
  data() {
    return {
      isLoaded: false,
    };
  },
  computed: {
    objectData() {
      return this.$store.getters.getSearchObjectLastSeen(this.lastSeenObjectNumber);
    },
    objectLocation() {
      return (this.objectData.seoLinkLocationName || this.objectData.seoLinkRegionName) || '';
    },
  },
};
</script>
